import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowLeft, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Header from "../Header";
import ContactConcierge from "../ContactConcierge";
import Accordion from 'react-bootstrap/Accordion';
import { useLocation } from "react-router-dom";
import { HashLink, HashLink as LinkHash } from 'react-router-hash-link';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import Seo from "../Seo";
import { ParallaxProvider } from "react-scroll-parallax";
import AdvancedBanner from "../AdvancedBanner";

const TemplateExperienceDetail = ({ experience }) => {

    const { t } = useTranslation();

    const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 767px)").matches);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.matchMedia("(max-width: 767px)").matches);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const location = useLocation();

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 6,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 3,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        },
    };

    const isWeddingsPage = location.pathname.includes('weddings');

    return (
        <div className="template-experience-detail">
            <Seo
                title={experience?.seoInformation?.title ?? "Memorable experiences | Feeling Italy"}
                description={experience?.seoInformation?.metaDescription ?? "Discover exclusive concierge services with Feeling Italy. From private chefs and luxury transfers to personalized tours and unique experiences, let us make your Mediterranean vacation truly unforgettable."}
                keywords={experience?.seoInformation?.keywords ?? "Concierge Services, Feeling Italy Concierge, Private Chef Italy, Luxury Transfers Amalfi Coast, Personalized Tours Italy, Exclusive Mediterranean Experiences, Tailored Travel Services, Amalfi Coast Luxury Services, Custom Travel Assistance, Premium Guest Experiences"}
                url={window.location.href}
            />
            <Header background={"transparent"} isStatic={true} />

            {/* Heading Section */}
            <section>
                <div className="row mx-0 heading-template-experience-detail">

                    <div className="col-lg-4 col-12 d-flex flex-column justify-content-center align-items-center background-white text-black pt-5 pb-5 pb-lg-0 heading-template-experience-detail-one px-4">
                        <div className="col-lg-8 col-12 ps-2 pe-0 position-relative mt-2">
                            <h1 className="title mb-5 mt-5">{experience?.heading?.title ?? ""}</h1>
                            <p className="paragraph text-black text-left mb-3 " dangerouslySetInnerHTML={{ __html: experience?.heading?.description ?? "" }}></p>
                        </div>
                        {!isMobile && <div className="arrow-down-cta d-flex align-items-center flex-column mt-5 ">
                            <button
                                className="text-uppercase border-none bg-transparent text-black cursor text-decoration-none d-flex align-items-center flex-column"
                                onClick={(e) => {
                                    e.preventDefault();
                                    document.getElementById("intro")?.scrollIntoView({ behavior: 'smooth' });
                                }}
                            >
                                {experience?.heading?.cta?.text ?? t("ScrollDown")}
                                <FontAwesomeIcon icon={faChevronDown} className="arrow-down-animation mt-2 bounce" />
                            </button>
                        </div>}

                    </div>
                    {experience?.heading && experience?.heading?.image && experience?.heading?.image[0] && (
                    <div className="col-lg-8 col-12 heading-template-experience-detail-two px-0">
                        <img 
                            className="w-100 img-experience-header shadow"
                            src={process.env.REACT_APP_SITE_URL + (experience?.heading?.image && (experience?.heading?.image[0]?.objectUrl ?? ""))} 
                            alt={experience?.heading?.image && (experience?.heading?.image[0]?.name ?? "")} 
                        />
                    </div>
                    )}
                </div>
            </section>

            {/* Intro Section */}
            <section className="padding-mobile">
                <div className="container">
                    <div className="row d-flex justify-content-center mt-5 mb-5 pt-5 pb-5 align-items-center template-experience-detail-intro" id="intro">
                        <div className="col-lg-4 col-12">
                            <h2 className="title text-uppercase text-black text-left mb-5">{experience?.intro?.title ?? ""}</h2>
                        </div>
                        <div className="col-lg-6 offset-lg-1 col-12">
                            <p className="paragraph text-black text-left mb-3" dangerouslySetInnerHTML={{ __html: experience?.intro?.description ?? ""}} />
                        </div>
                    </div>
                </div>
            </section>
            
            {/* Benefits Section */}
            {(experience && experience.benefits && experience.benefits.length) > 0 ? (
                experience.benefits.some(benefit => {
                    const hasContent = benefit.description || benefit.title || (benefit.image && benefit.image.length > 0);
                    const hasCtaContent = benefit.cta && (benefit.cta.text || benefit.cta.url || benefit.cta.target);
                    return hasContent || hasCtaContent;
                }) 
            ? 
            (<section>
                <div className="pb-5 mb-5">
                    <div className="position-relative text-center">
                        {experience?.benefits[0] && (
                            <div className="background-black parallax-template-experience-detail">
                                <ParallaxProvider>
                                    <AdvancedBanner
                                        description={experience?.benefits[0]?.description ?? ""}
                                        title={experience?.benefits[0].title ?? ""}
                                        cta={experience?.benefits[0].cta}
                                        urlImage={experience?.benefits[0]?.image && (experience?.benefits[0]?.image[0]?.objectUrl ?? "")}
                                    />
                                </ParallaxProvider>
                            </div>
                        )}
                        <div className="row overflow-hidden m-0 descriptions-template-experience-detail content-align-start background-black justify-content-center g-5">
                            {experience?.benefits.slice(1, 4).map((benefit, index) => (
                                <div className="col-lg-3 col-md-10 col-12 mx-5 d-flex flex-column align-items-center text-center" key={index}>
                                    <h3 className="sub-title text-uppercase text-white">
                                        {benefit?.title ?? ""}
                                    </h3>
                                    <p className="paragraph text-white mt-4"
                                        dangerouslySetInnerHTML={{ __html: benefit?.description ?? "" }}>
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
                ) : (
                    <div></div>
                )
            ) : (
                <div></div>
            )}

             {/* Exclusive Offers Section */}
             {experience && experience.offers && experience.offers.length > 0 ? (
                experience.offers.some((offer, index) => {
                    if (index === 0) {
                        return offer.title || offer.description || (offer.cta && (offer.cta.text || offer.cta.url || offer.cta.target));
                    } else {
                        return offer.title || offer.description || (offer.image && offer.image.length > 0);
                    }
                }) ? (
                    <section className="padding-mobile" id="exclusive-offers">
                        <div className="container">
                            <div className="row align-items-center justify-content-center mb-5 mt-5">
                                {experience?.offers[0] && (
                                    <>
                                        <div className="col-lg-8 col-12 text-center">
                                            <h5 className="title text-uppercase mb-5">{experience?.offers[0].title}</h5>
                                        </div>
                                        <div className="col-lg-8 col-12">
                                            <p className="paragraph text-black text-center" dangerouslySetInnerHTML={{ __html: experience?.offers[0].description }}></p>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="row mt-5 d-flex align-items-stretch">
                                <div className="col-lg-6 pe-lg-4 d-flex flex-column mb-4 mb-lg-0" >
                                    {experience?.offers && experience?.offers[1] && experience?.offers[1]?.image && experience?.offers[1]?.image[0]?.objectUrl && (
                                        <HashLink to="#contact-travel-designer" smooth>
                                            <img src={process.env.REACT_APP_SITE_URL + (experience?.offers[1]?.image && (experience?.offers[1]?.image[0]?.objectUrl ?? ""))} className="h-100 w-100 object-fit-cover img-threeCards-first"
                                                alt={experience?.offers[1]?.image && (experience?.offers[1]?.image[0]?.name ?? "")}
                                            />
                                        </HashLink>
                                    )}
                                    <div>
                                        <HashLink to={"#contact-travel-designer"} smooth className="text-black">
                                            <h3 className="pt-4 lineEffectBlack text-uppercase text-left title">{experience?.offers[1]?.title ?? ""}</h3>
                                        </HashLink>
                                        <div className="text-start p-no-margin pb-5" dangerouslySetInnerHTML={{ __html: experience?.offers[1]?.description ?? "" }}></div>
                                    </div>
                                </div>
                                <div className="col-lg-6 ps-lg-4 d-flex flex-column justify-content-between mb-4 mb-lg-0">
                                    <div>
                                    {experience?.offers && experience?.offers[2]?.image && experience?.offers[2]?.image[0]?.objectUrl && (
                                        <HashLink to="#contact-travel-designer" smooth>
                                            <img src={process.env.REACT_APP_SITE_URL + (experience?.offers[2]?.image && (experience?.offers[2]?.image[0]?.objectUrl ?? ""))} className="h-auto w-100 object-fit-cover img-threeCards-right"
                                                alt={experience?.offers[2]?.image && (experience?.offers[2]?.image[0]?.name ?? "")}
                                            />
                                        </HashLink>
                                    )}
                                        <div>
                                            <HashLink to={"#contact-travel-designer"} smooth className="text-black">
                                                <h3 className="pt-4 lineEffectBlack text-uppercase text-left title">{experience?.offers[2]?.title ?? ""}</h3>
                                            </HashLink>
                                            <div className="text-start p-no-margin pb-5" dangerouslySetInnerHTML={{ __html: experience?.offers[2]?.description ?? "" }}></div>
                                        </div>
                                    </div>

                                    <div>
                                    {experience?.offers && experience?.offers[3]?.image && experience?.offers[3]?.image[0]?.objectUrl && (
                                        <HashLink to="#contact-travel-designer" smooth>
                                            <img src={process.env.REACT_APP_SITE_URL + (experience?.offers[3]?.image && (experience?.offers[3]?.image[0]?.objectUrl ?? ""))} className="h-auto w-100 object-fit-cover img-threeCards-right"
                                                alt={experience?.offers[3]?.image && (experience?.offers[3]?.image[0]?.name ?? "")}
                                            />
                                        </HashLink>
                                    )}
                                        <div>
                                            <HashLink to={"#contact-travel-designer"} smooth className="text-black">
                                                <h3 className="pt-4 lineEffectBlack text-uppercase text-left title">{experience?.offers[3]?.title ?? ""}</h3>
                                            </HashLink>
                                            <div className="text-start p-no-margin pb-5" dangerouslySetInnerHTML={{ __html: experience?.offers[3]?.description ?? "" }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <div></div>
                )
            ) : (
                <div></div>
            )}

            {/* CTA */}
            {experience?.offers?.[0]?.cta?.url && experience?.offers?.[0]?.cta?.text && (
                <div className="d-flex justify-content-center template-experience-detail-offers px-5 arrowEffectContainer">
                    {experience?.offers?.[0]?.cta?.url?.includes("#") ? (
                        <HashLink
                            className="background-black text-white link py-3 px-4 w-lg-50 text-start border-none text-uppercase"
                            target={experience?.offers?.[0]?.cta?.target ?? "_self"}
                            to={experience?.offers?.[0]?.cta?.url ?? "#"}
                        >
                            {experience?.offers?.[0]?.cta?.text ?? t("BookYourExperience")}
                            <FontAwesomeIcon icon={faArrowRight} className="paddingArrow effectArrow" />
                        </HashLink>
                    ) : (
                        <Link
                            className="background-black text-white link py-3 px-4 w-lg-50 text-start border-none text-uppercase"
                            target={experience?.offers?.[0]?.cta?.target ?? "_self"}
                            to={experience?.offers?.[0]?.cta?.url ?? "#"}
                        >
                            {experience?.offers?.[0]?.cta?.text ?? t("BookYourExperience")}
                            <FontAwesomeIcon icon={faArrowRight} className="paddingArrow effectArrow" />
                        </Link>
                    )}
                </div>
            )}
            
            {/* REVIEWS */}
            <section className="padding-mobile">
                <div className="container mt-5">
                    <div className="row d-flex flex-column align-items-center justify-content-center">
                        {experience?.reviews && (experience?.reviews?.length ?? 0) > 0 && experience?.reviews[0] && (
                            <div className="col-lg-8 col-12">
                                <h4 className="text-uppercase title text-center"> {experience?.reviews[0].title}</h4>
                                <p className="paragraph text-center mt-4">
                                    {experience?.reviews[0].description}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
                {experience?.reviews && experience?.reviews.length > 1 && (
                    <div className="mt-3">
                        <Carousel
                            responsive={responsive}
                            infinite={true}
                            centerMode={true}
                            autoPlay={true}
                            showDots={false}
                            arrows={false}
                            customTransition="linear 30s"
                            containerClass="carousel-container-reviews d-flex justify-content-center"
                            itemClass="carousel-item-review"
                        >
                            {experience?.reviews.slice(1).map((review, index) => (
                                <div
                                    key={index}
                                    className="p-4 mb-2 review-card d-flex flex-column justify-content-between"
                                >
                                    <p className="paragraph mb-0 description-review">
                                        {review?.description ?? ""}
                                    </p>
                                    <p className="paragraph mb-0 name-review">
                                        {review?.title ?? ""}
                                    </p>
                                </div>
                            ))}
                        </Carousel>
                    </div>

                )}
            </section>

            <ContactConcierge margin={isMobile ? "-200px" : "-100px"} />

            {
                experience?.faq && (
                    <section className="padding-mobile">
                        <div className="container-fluid d-flex justify-content-center align-items-center">
                            <Accordion defaultActiveKey={null} className="mt-5 accordion-detail w-75">
                                {experience?.faq.map((item, index) => (
                                    <Accordion.Item eventKey={index.toString()} key={index} className="mb-5">
                                        <Accordion.Header>{item.title.toUpperCase()}</Accordion.Header>
                                        <Accordion.Body>
                                            <p
                                                className="m-0"
                                                dangerouslySetInnerHTML={{ __html: item.description }}>
                                            </p>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                        </div>
                    </section>
                )
            }
            {!isWeddingsPage && !isMobile && (
                <div className="arrowEffectContainer pb-5 ps-lg-5 ms-lg-5">
                    <Link
                        className="back-experience-cta ms-5 ps-5 mt-5 background-white text-black px-4 w-lg-50 text-start border-none text-uppercase effectArrowLeft link"
                        to={window.location.pathname.split(experience.seoInformation.linkUrl)[0]}
                        target={"_self"}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} className="mt-1 paddingArrow effectArrowLeft" color="black" fontSize={"16px"} />
                        {t("BackToExperiences")}
                    </Link>
                </div>
            )}

        </div>
    );
};

export default TemplateExperienceDetail;
